import { render } from "./EventCategories.vue?vue&type=template&id=9352b1de&scoped=true"
import script from "./EventCategories.vue?vue&type=script&lang=js"
export * from "./EventCategories.vue?vue&type=script&lang=js"

import "./EventCategories.vue?vue&type=style&index=0&id=9352b1de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9352b1de"]])

export default __exports__